import * as React from 'react';
import { AVATAR_TEXT_TYPE } from '../Avatar/constants';
import { classes, st } from './AvatarGroup.base.st.css';
import { DATA_HOOKS } from './constants';
export function AvatarGroupBase({ items = [], avatarContainerClassName, renderAvatar, maxAmount = 5, className, renderHiddenAvatarCount, ...rest }) {
    const shouldShowHiddenAvatarCount = renderHiddenAvatarCount && items.length - maxAmount > 0;
    const hiddenAvatarIndicationText = `+${Math.min(items.length - maxAmount, 99)}`;
    return (React.createElement("div", { className: st(classes.root, className), ...rest },
        items.slice(0, maxAmount).map((props, i) => (React.createElement("div", { className: st(classes.avatarContainer, avatarContainerClassName), key: `${props.src}-${i}-${props.name}` }, renderAvatar({ ...props, 'data-hook': DATA_HOOKS.avatar })))),
        shouldShowHiddenAvatarCount && (React.createElement("div", { className: st(classes.avatarContainer, avatarContainerClassName) }, renderHiddenAvatarCount({
            name: hiddenAvatarIndicationText,
            textType: AVATAR_TEXT_TYPE.plain,
            'data-hook': DATA_HOOKS.hiddenAvatarCount,
        })))));
}
//# sourceMappingURL=AvatarGroup.base.js.map